import { useGraphqlQuery } from "@bsm/component";
import { TContractsResponse } from "@bsm/graphql";
import { OrganizationEmployeesQuery } from "../query/OrganizationEmployeesQuery";

export const useEmployeeListQuery = () => {
  return useGraphqlQuery<OrganizationEmployeesQuery, TContractsResponse>(
    new OrganizationEmployeesQuery(),
    { suspense: true },
  );
};
